// src/components/FacebookOAuth.jsx
import React from 'react';
import { FACEBOOK_CLIENT_ID, FACEBOOK_REDIRECT_URI } from '../../config';

const FacebookOAuth = ({ name, icon }) => {
  const handleFacebookLogin = () => {
    const baseUrl = 'https://www.facebook.com/v12.0/dialog/oauth';
    const scope = 'email';
    // Сохраняем redirect path в state параметре OAuth для надёжности
    const redirectPath = sessionStorage.getItem('authRedirectPath') || '';
    const params = new URLSearchParams({
      client_id: FACEBOOK_CLIENT_ID,
      redirect_uri: FACEBOOK_REDIRECT_URI,
      response_type: 'code',
      scope: scope,
      display: 'popup',
      state: redirectPath,
    });

    window.location.href = `${baseUrl}?${params.toString()}`;
  };

  return (
    <div>
      <button className='auth-button' onClick={handleFacebookLogin}>
        {icon} {name}
      </button>
    </div>
  );
};

export default FacebookOAuth;